import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { CompanyShareholdersResponse } from '../models/shareholder';
import { File } from 'core/models/common';

export const onGetCompanyShareholderLists = async (page = 1) => {
	try {
		const response = await axios.get<JsonResponse<CompanyShareholdersResponse>>('dashboard/shareholder-list', { params: { page } });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onDownloadCompanyShareholderList = async (id: number) => {
	try {
		const response = await axios.get<JsonResponse<{ file_url: string }>>(`dashboard/shareholder-list/${id}/download`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onDownloadCompanyShareholderExcel = async (id: number) => {
	try {
		const response = await axios.get<JsonResponse<{ file: File }>>(`dashboard/shareholder-list/${id}/export`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
